import React, { useState } from 'react';

import ImageViewer from './ImageViewer';

interface ClickableImagePreviewProps {
  src: string;
  srcs?: string[];
  currentIndex?: number;
  alt: string;
  className?: string;
}

const ClickableImagePreview: React.FC<ClickableImagePreviewProps> = ({
  src,
  srcs,
  currentIndex = 0,
  alt,
  className = 'h-10 w-auto max-w-full object-contain',
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsViewerOpen(true)}
        className="cursor-zoom-in"
        aria-label={`Preview ${alt}`}
      >
        <img src={src} alt={alt} className={className} />
      </button>

      {isViewerOpen && (
        <ImageViewer
          src={src}
          srcs={srcs}
          initialIndex={currentIndex}
          trigger={isViewerOpen}
          onClose={() => setIsViewerOpen(false)}
        />
      )}
    </>
  );
};

export default ClickableImagePreview;
